import { useSyncExternalStore } from "react";

// 이름이 `sb-` 로 시작하면 Supabase 세션 항목이다(legacy lib/supabase/session-key 의 쿠키 규칙을 브라우저 저장소에 그대로).
const SESSION_PREFIX = "sb-";

export const hasSessionEntry = (names: readonly string[]): boolean => names.some((name) => name.startsWith(SESSION_PREFIX));

const storageNames = (): string[] => {
  try {
    return Object.keys(window.localStorage);
  } catch {
    return [];
  }
};

const subscribe = (onChange: () => void): (() => void) => {
  window.addEventListener("storage", onChange);
  return () => window.removeEventListener("storage", onChange);
};

// 프리렌더·첫 hydrate 는 로그인 전(false)으로 그리고, 붙은 뒤 브라우저 세션을 본다 — 서버 HTML 과 첫 화면이 같다.
export const useSignedIn = (): boolean =>
  useSyncExternalStore(
    subscribe,
    () => hasSessionEntry(storageNames()),
    () => false,
  );
